import { CopyrightIcon, Globe, Mail } from 'lucide-react'
import React, { Fragment, useEffect, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';


function Siteinfo({ getsiteSetting }) {
    const methods = useFormContext()
    const { control, formState, setError, setValue, clearErrors, reset } = methods
    const { errors } = formState;

    const [favicon, setFavicon] = useState("")
    const [sitelogo, setSitelogo] = useState("")

    useEffect(() => {
        if (getsiteSetting) {
            setFavicon(getsiteSetting?.favicon)
            setSitelogo(getsiteSetting?.logo)
            reset(getsiteSetting)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getsiteSetting])

    const readFileAsync1 = (file) => {
        return new Promise(
            (resolve, reject) => {
                if (!file) return

                const reader1 = new FileReader()
                reader1.onload = () => {
                    resolve(reader1.result)
                }
                reader1.onerror = reject
                reader1.readAsDataURL(
                    file
                )
            }
        )
    }

    const handlefavIcon = (event) => {
        let img = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            const imgCheck = new Image();
            imgCheck.src = event.target.result;
            imgCheck.onload = async () => {
                if (imgCheck.width >= 1 && imgCheck.height >= 1) {

                    if (img.size < 2 * 1024 * 1024) {
                        const newImage1 = await readFileAsync1(img)
                        setFavicon(newImage1);
                        setValue("favicon", img)
                    } else {
                        setError("favicon", { message: "Image Size Must be Less than 2MB." });
                    }
                } else {
                    setError("favicon", { message: "Image Dimensions should be 16 x 16 Pixels." });
                }
            };

            imgCheck.onerror = (error) => {
            };
        }
        reader.onerror = (error) => {
        };
        reader.readAsDataURL(img);
    }

    const handlesiteLogo = (event) => {
        let img = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            const imgCheck = new Image();
            imgCheck.src = event.target.result;
            imgCheck.onload = async () => {
                if (imgCheck.width >= 1 && imgCheck.height >= 1) {

                    if (img.size < 2 * 1024 * 1024) {
                        const newImage1 = await readFileAsync1(img)
                        setSitelogo(newImage1);
                        setValue("logo", img)
                    } else {
                        setError("logo", { message: "Image Size Must be Less than 2MB." });
                    }
                }
                else {
                    setError("logo", { message: "Image Dimensions should be 100 x 100 Pixels." });
                }
            };

            imgCheck.onerror = (error) => {
            };
        }
        reader.onerror = (error) => {
        };
        reader.readAsDataURL(img);
    }

    return (
        <Fragment>
            <div className='col-md-6'>
                <div className="row align-items-center mb-4">
                    <label className="col-sm-3 col-form-label" htmlFor="fbid">
                        Site Name
                    </label>
                    <div className="col-sm-9">
                        <div className="input-group">
                            <button type="button" className="btn p-0 input-group-icon border-0">
                                <Globe size={20} color='#aaa9a9' />
                            </button>
                            <Controller
                                name="siteName"
                                control={control}
                                render={({ field }) => (
                                    <input
                                        {...field}
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter site name"
                                    />
                                )}
                            />
                        </div>
                        {errors.siteName && <p className='errMsg'>{errors.siteName.message}</p>}
                    </div>
                </div>
                <div className="row align-items-center mb-4">
                    <label className="col-sm-3 col-form-label" htmlFor="fbid">
                        Contact E-mail
                    </label>
                    <div className="col-sm-9">
                        <div className="input-group">
                            <button type="button" className="btn p-0 input-group-icon border-0">
                                <Mail size={20} color='#aaa9a9' />
                            </button>
                            <Controller
                                name="email"
                                control={control}
                                render={({ field }) => (
                                    <input
                                        {...field}
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter contact e-mail"
                                    />
                                )}
                            />
                        </div>
                        {errors.email && <p className='errMsg'>{errors.email.message}</p>}
                    </div>
                </div>
                <div className="row align-items-center mb-4">
                    <label className="col-sm-3 col-form-label" htmlFor="fbid">
                        Copyrights
                    </label>
                    <div className="col-sm-9">
                        <div className="input-group">
                            <button type="button" className="btn p-0 input-group-icon border-0">
                                <CopyrightIcon size={20} color='#aaa9a9' />
                            </button>
                            <Controller
                                name="copyrights"
                                control={control}
                                render={({ field }) => (
                                    <input
                                        {...field}
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter copy rights"
                                    />
                                )}
                            />
                        </div>
                        {errors.copyrights && <p className='errMsg'>{errors.copyrights.message}</p>}
                    </div>
                </div>
            </div>
            <div className='col-md-6'>
                <div className='mb-4'>
                    <div className="row align-items-center mb-4">
                        <label className="col-sm-3 col-form-label" htmlFor="formFileMultiple1">
                            Favicon
                        </label>
                        <div className="col-sm-9">
                            <input
                                name='favicon' className="form-control"
                                accept='.jpg,.png,.jpeg'
                                type="file" id="formFileMultiple1"
                                onChange={async (e) => {
                                    try {
                                        let img = e.target.files[0]
                                        const reader = new FileReader();
                                        clearErrors("favicon")
                                        setValue("favicon", null)
                                        setFavicon(null)
                                        reader.onload = (event) => {
                                            const bytes = new Uint8Array(event.target.result);
                                            if ((bytes[0] === 0x89 && bytes[1] === 0x50) || (bytes[0] === 0xFF && bytes[1] === 0xD8)) { // png, apng, jpg, jpeg
                                                handlefavIcon(e)
                                            } else {
                                                setError("favicon", { message: 'Please select image file' })
                                            }
                                        };
                                        reader.onerror = (error) => {
                                        };
                                        reader.readAsArrayBuffer(img);
                                    } catch (e) { }
                                }} />
                            {errors.favicon && <p className='errMsg'>{errors.favicon.message}</p>}
                        </div>
                    </div>
                    <div className="text-center">
                        {favicon && <img src={favicon} alt="avatar" className="avatar-xs rounded-circle" />}
                    </div>
                </div>
                <div className='mb-4'>
                    <div className="row align-items-center mb-4">
                        <label className="col-sm-3 col-form-label" htmlFor="formFileMultiple2">
                            Site Logo
                        </label>
                        <div className="col-sm-9">
                            <input
                                name='logo' className="form-control"
                                accept='.jpg,.png,.jpeg'
                                type="file" id="formFileMultiple2"
                                onChange={async (e) => {
                                    try {
                                        let img = e.target.files[0]
                                        const reader = new FileReader();
                                        clearErrors("logo")
                                        setValue("logo", null)
                                        setSitelogo(null)
                                        reader.onload = (event) => {
                                            const bytes = new Uint8Array(event.target.result);
                                            if ((bytes[0] === 0x89 && bytes[1] === 0x50) || (bytes[0] === 0xFF && bytes[1] === 0xD8)) { // png, apng, jpg, jpeg
                                                handlesiteLogo(e)
                                            } else {
                                                setError("logo", { message: 'Please select image file' })
                                            }
                                        };
                                        reader.onerror = (error) => {
                                        };
                                        reader.readAsArrayBuffer(img);
                                    } catch (e) { }
                                }} />
                            {errors.logo && <p className='errMsg'>{errors.logo.message}</p>}
                        </div>
                    </div>
                    <div className="text-center">
                        {sitelogo && <img src={sitelogo} width={150} className='sitesetLogo' alt="logo" />}
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
Siteinfo.propTypes = {
    getsiteSetting: PropTypes.any.isRequired,
};
export default Siteinfo